(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dicci-black-friday-campaign"] && !Shopify.designMode) return;
  try {
    

(function() {
  var instances = new Map();

  function calendarStamp(date) {
    return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  }

  function calendarText(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
  }

  function foldCalendarLine(value) {
    var encoder = new TextEncoder();
    var line = '';
    var length = 0;
    var lines = [];
    Array.from(value).forEach(function(character) {
      var bytes = encoder.encode(character).length;
      if (length + bytes > 75) {
        lines.push(line);
        line = ' ';
        length = 1;
      }
      line += character;
      length += bytes;
    });
    lines.push(line);
    return lines.join('\r\n');
  }

  function dispose(root) {
    var instance = instances.get(root);
    if (!instance) return;
    window.clearInterval(instance.timer);
    if (instance.calendarUrl) URL.revokeObjectURL(instance.calendarUrl);
    instances.delete(root);
  }


  function init(scope) {
    scope.querySelectorAll('[data-bf-campaign]').forEach(function(root) {
      if (instances.has(root)) return;
      var earlyAt = new Date(root.dataset.earlyAt);
      var startAt = new Date(root.dataset.startAt);
      var endAt = new Date(root.dataset.endAt);
      if ([earlyAt, startAt, endAt].some(function(date) { return Number.isNaN(date.getTime()); })) return;
      var messages = JSON.parse(root.querySelector('[data-bf-messages]').textContent);
      var locale = root.dataset.locale || 'en';
      var format = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Lisbon', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false });
      var weekdayFormat = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Lisbon', weekday: 'short' });
      var lastState = null;
      var nextStockRefresh = 0;
      var stockLoading = false;

      var calendarEnd = new Date(earlyAt.getTime() + 30 * 60000);
      var calendarDescription = messages.calendar_details + '\n\n' + root.dataset.campaignUrl;
      var calendarLines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//DICCI//Black Friday Early Access//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        'UID:dicci-early-access-' + calendarStamp(earlyAt) + '@dicci.eu',
        'DTSTAMP:' + calendarStamp(new Date()),
        'DTSTART:' + calendarStamp(earlyAt),
        'DTEND:' + calendarStamp(calendarEnd),
        'SUMMARY:' + calendarText(messages.calendar_event_title),
        'DESCRIPTION:' + calendarText(calendarDescription),
        'LOCATION:' + calendarText(root.dataset.campaignUrl),
        'URL:' + root.dataset.campaignUrl,
        'TRANSP:TRANSPARENT',
        'BEGIN:VALARM',
        'TRIGGER:-PT15M',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + calendarText(messages.calendar_event_title),
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
      ];
      var calendarFile = calendarLines.map(foldCalendarLine).join('\r\n') + '\r\n';
      var calendarBlobUrl = URL.createObjectURL(new Blob([calendarFile], { type: 'text/calendar;charset=utf-8' }));
      root.querySelectorAll('[data-bf-ics]').forEach(function(link) {
        link.href = calendarBlobUrl;
      });
      var googleUrl = new URL('https://calendar.google.com/calendar/render');
      googleUrl.searchParams.set('action', 'TEMPLATE');
      googleUrl.searchParams.set('text', messages.calendar_event_title);
      googleUrl.searchParams.set('dates', calendarStamp(earlyAt) + '/' + calendarStamp(calendarEnd));
      googleUrl.searchParams.set('details', calendarDescription);
      googleUrl.searchParams.set('location', root.dataset.campaignUrl);
      googleUrl.searchParams.set('ctz', 'Europe/Lisbon');
      root.querySelector('[data-bf-google-calendar]').href = googleUrl.toString();
      var outlookUrl = new URL('https://outlook.live.com/calendar/0/deeplink/compose');
      outlookUrl.searchParams.set('path', '/calendar/action/compose');
      outlookUrl.searchParams.set('rru', 'addevent');
      outlookUrl.searchParams.set('subject', messages.calendar_event_title);
      outlookUrl.searchParams.set('startdt', earlyAt.toISOString());
      outlookUrl.searchParams.set('enddt', calendarEnd.toISOString());
      outlookUrl.searchParams.set('body', calendarDescription);
      outlookUrl.searchParams.set('location', root.dataset.campaignUrl);
      outlookUrl.searchParams.set('allday', 'false');
      root.querySelector('[data-bf-outlook-calendar]').href = outlookUrl.toString().replace(/\+/g, '%20');


      root.querySelectorAll('[data-bf-date="early"], [data-bf-date="hero-early"]').forEach(function(date) {
        date.textContent = format.format(earlyAt);
      });
      root.querySelector('[data-bf-date="public"]').textContent = format.format(startAt) + ' — ' + format.format(endAt);

      function getState(now) {
        if (now >= endAt) return 'ended';
        if (now >= startAt) return 'live';
        if (now >= earlyAt) return 'early';
        var weekday = weekdayFormat.format(now);
        return weekday === 'Sat' || weekday === 'Sun' ? 'weekend' : 'drops';
      }

      async function readStockPage(page) {
        var url = new URL(root.dataset.stockUrl, window.location.origin);
        url.searchParams.set('view', 'dicci-bf-stock');
        url.searchParams.set('page', String(page));
        if (root.dataset.previewThemeId) url.searchParams.set('preview_theme_id', root.dataset.previewThemeId);
        var response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Stock endpoint unavailable');
        var data = await response.json();
        if (data.page !== page || !Number.isInteger(data.pages) || !Number.isInteger(data.sold_out) || !Number.isInteger(data.variants) || !Number.isInteger(data.scanned_products) || !Number.isInteger(data.total_products) || data.sold_out < 0 || data.sold_out > data.variants) {
          throw new Error('Incomplete stock count');
        }
        return data;
      }

      async function refreshStock() {
        if (stockLoading || !root.isConnected) return;
        stockLoading = true;
        nextStockRefresh = Date.now() + 300000;
        try {
          var first = await readStockPage(1);
          var pages = [first];
          for (var page = 2; page <= first.pages; page += 3) {
            var batch = [];
            for (var index = page; index < page + 3 && index <= first.pages; index++) batch.push(readStockPage(index));
            pages.push.apply(pages, await Promise.all(batch));
          }
          if (!root.isConnected) return;
          var scanned = pages.reduce(function(total, current) { return total + current.scanned_products; }, 0);
          var variants = pages.reduce(function(total, current) { return total + current.variants; }, 0);
          var soldOut = pages.reduce(function(total, current) { return total + current.sold_out; }, 0);
          if (scanned !== first.total_products || pages.some(function(current) { return current.total_products !== first.total_products; })) throw new Error('Stock catalogue changed while counting');
          var stock = root.querySelector('[data-bf-stock]');
          if (!variants) { stock.hidden = true; return; }
          var percentage = soldOut / variants;
          stock.querySelector('[data-bf-stock-count]').textContent = new Intl.NumberFormat(locale).format(soldOut);
          stock.querySelector('[data-bf-stock-total]').textContent = new Intl.NumberFormat(locale).format(variants);
          stock.querySelector('[data-bf-stock-percent]').textContent = new Intl.NumberFormat(locale, { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(percentage);
          stock.querySelector('[data-bf-stock-meter]').setAttribute('aria-valuenow', (percentage * 100).toFixed(1));
          stock.querySelector('[data-bf-stock-bar]').style.width = (percentage * 100) + '%';
          stock.querySelector('[data-bf-stock-updated]').textContent = format.format(new Date());
          stock.dataset.soldOut = String(soldOut);
          stock.dataset.variants = String(variants);
          stock.dataset.products = String(scanned);
          stock.hidden = false;
        } catch (error) {
          nextStockRefresh = Date.now() + 60000;
        } finally {
          stockLoading = false;
        }
      }

      function render() {
        if (!root.isConnected) {
          dispose(root);
          return;
        }
        var now = new Date();
        var state = getState(now);
        root.querySelectorAll('[data-bf-calendar-add]').forEach(function(calendar) { calendar.hidden = now >= earlyAt; });
        root.querySelectorAll('[data-bf-gift]').forEach(function(gift) { gift.hidden = now >= startAt; });
        var ctaKey = 'view_offers';
        var link = '#bf-ofertas-' + root.dataset.sectionId;
        var target = earlyAt;
        var countdownKey = 'early_in';
        if (state === 'weekend') {
          ctaKey = 'weekend_cta';
          link = root.dataset.weekendLink;
        } else if (state === 'early') {
          ctaKey = 'early_cta';
          link = root.dataset.liveLink;
          target = startAt;
          countdownKey = 'public_in';
        } else if (state === 'live') {
          ctaKey = 'live_cta';
          link = root.dataset.liveLink;
          target = endAt;
          countdownKey = 'ends_in';
        } else if (state === 'ended') {
          ctaKey = 'shop_dicci';
          link = root.dataset.weekendLink;
          target = null;
        }
        if (state !== lastState) {
          root.dataset.state = state;
          root.querySelector('[data-bf-state-label]').textContent = messages[state + '_label'];
          root.querySelector('[data-bf-state-title]').textContent = messages[state + '_title'];
          root.querySelector('[data-bf-state-copy]').textContent = messages[state + '_copy'];
          var statusLink = root.querySelector('[data-bf-status-link]');
          statusLink.href = link;
          statusLink.textContent = messages[ctaKey];
          var sticky = root.querySelector('[data-bf-sticky-link]');
          var beforePublic = state === 'drops' || state === 'weekend' || state === 'early';
          sticky.href = beforePublic ? '#bf-hero-signup-' + root.dataset.sectionId : link;
          sticky.textContent = beforePublic ? messages.access_signup : messages[ctaKey];
          var heroLink = root.querySelector('[data-bf-hero-live-link]');
          heroLink.hidden = beforePublic;
          heroLink.href = link;
          heroLink.textContent = messages[ctaKey];
          lastState = state;
        }
        var countdown = root.querySelector('[data-bf-countdown]');
        countdown.hidden = !target;
        if (target) {
          var seconds = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
          var values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
          countdown.querySelector('[data-bf-countdown-label]').textContent = messages[countdownKey];
          Object.keys(values).forEach(function(unit) {
            var element = countdown.querySelector('[data-bf-unit="' + unit + '"]');
            var value = String(values[unit]).padStart(2, '0');
            if (element.textContent !== value) element.textContent = value;
          });
        }
        if (Date.now() >= nextStockRefresh && !document.hidden) refreshStock();
      }

      render();
      instances.set(root, { timer: window.setInterval(render, 1000), calendarUrl: calendarBlobUrl });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    instances.forEach(function(instance, root) {
      if (event.target.contains(root)) {
        dispose(root);
      }
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
